<template lang="pug">
  div
    .row.mb-4.mt-3
      .col.text-center
        input(
          id="rooms-uploader-input"
          type="file"
          ref="fileInput"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.xlsx"
          @change="onFileChanged"
        )

        button.btn.btn-outline-primary(
          type="button"
          @click="chooseFile"
        )
          span {{ $t('room.choose_a_file') }}

        .file-name
          p {{ uploadedFileName }}

        .invalid-feedback(v-if="uploadError")
          span {{ uploadError }}
    .row
      .col.text-center
        button.btn.btn-outline-primary.mr-3.py-0.px-4(@click="close") {{ $t('property.cancel') }}
        button.btn.btn-primary.py-0.mr-1(@click="uploadFileWithRooms") {{ $t('confirm') }}
</template>

<script>
  import { api } from '@/api'
  import { get } from 'lodash'

  export default {
    props: {
      propertyId: {
        type: Number,
        default: 0
      }
    },

    data() {
      return {
        uploadedFileName: '',
        uploadError: '',
        uploadedRooms: {},
        uploadErrors: {},
        headers:  {
          'Accept': 'application/json',
          'Content-Type': 'multipart/form-data'
        }
      }
    },

    computed: {
      uploadRoomsUrl() {
        return `/properties/${this.propertyId}/rooms/upload_xlsx`
      }
    },

    watch: {
      uploadedFileName() {
        this.uploadError = ''
      }
    },

    methods: {
      onFileChanged() {
        this.uploadedFileName = get(this.$refs.fileInput, 'files.0.name') || ''
      },

      chooseFile() {
        this.$refs.fileInput.click()
      },

      uploadFileWithRooms() {
        const file = this.$refs.fileInput.files[0]

        if (file) {
          if (file.type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            this.uploadError = this.$t('errors.only_xlsx_allowed')
          } else {
            this.sendFile(file)
          }
        } else {
          this.uploadError = this.$t('room.choose_a_file')
        }
      },

      sendFile(file) {
        let formData = new FormData();
        formData.append('file', file);

        api.post(this.uploadRoomsUrl, formData, { headers: this.headers })
          .then(response => this.$emit('success', response.data['data']))
          .catch(error => this.$emit('error', error.response.data['errors']))
          .finally(() => this.close())
      },

      close() {
        this.$emit('close')
      }
    }
  }
</script>

<style lang="scss" scoped>
.invalid-feedback {
  color: #dc3545;
  display: block;
  font-size: 100%;
  margin-top: 0.25rem;
  width: 100%;
}

.text-center {
  #rooms-uploader-input {
    display: none;
  }

  .file-name {
    margin-top: 2%;
  }
}
</style>
